import { SmokeTestHistoryContract } from '@terra/shared-contracts-smoke-test-history';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'ai';

export const smokeTestHistoryClient = createTerraOrpcClient({
  contract: SmokeTestHistoryContract,
  serviceName: SERVICE_NAME,
});
